export default function testBlock(element, data) {
    let questionIndex = 1;
    let score = 0;
    
    showQuestion(questionIndex);

    function showQuestion(index) {
        element.querySelectorAll('.test__block_item').forEach(el => el.classList.remove('current'));

        const next = element.querySelector(`.test__block_item[data-number="${index}"]`);
        if (next) next.classList.add('current');
    }

    function showResults(score) {
        element.querySelectorAll('.test__block_item').forEach(el => el.classList.remove('current'));
        let resultClass;
        let paddingSize = 'normal';

        if (score >= 3) {
            resultClass = '.result-1';
            paddingSize = 'sm';
        } else if (score < 3 && score > 0) {
            resultClass = '.result-2';
        } else {
            resultClass = '.result-3';
        }
        const result = element.querySelector(resultClass);

        if (result) {
            result.classList.add('current');
            element.classList.add('result');
            element.querySelector('.test__container').classList.add('hidden');
            element.querySelector('.result__container').classList.remove('hidden');
            element.querySelector('.result__container').classList.add(paddingSize);
        } else {
            score = 0;
            showQuestion(1);
        }
    }

    element.querySelectorAll('.test__block_answer').forEach(answer => {
        answer.addEventListener('click', () => {
            const hasRisk = parseInt(answer.dataset.has_risk || '0');
            
            if (hasRisk === 1) score++;

            questionIndex++;

            const nextQuestion = element.querySelector(`.test__block_item[data-number="${questionIndex}"]`);

            if (nextQuestion) {
                showQuestion(questionIndex);
            } else {
                showResults(score);
            }
        });
    });
};